import type { CampRegistrationStatus } from "@/server/platform/db/schema/camp-registrations";

const ALLOWED: Record<CampRegistrationStatus, CampRegistrationStatus[]> = {
  pending: ["contacted", "rejected", "duplicate"],
  contacted: ["pending", "confirmed", "rejected", "duplicate"],
  confirmed: ["pending", "converted", "rejected"],
  rejected: [],
  duplicate: ["pending", "contacted", "confirmed"],
  converted: [],
};

export function canTransitionCampRegistrationStatus(
  from: CampRegistrationStatus,
  to: CampRegistrationStatus,
): boolean {
  if (from === to) return true;
  return ALLOWED[from]?.includes(to) ?? false;
}
